export function AddOrderModalIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="4" y="4" width="16" height="18" rx="3" fill="#D4D5D8" />
      <rect x="8" y="2" width="8" height="4" rx="1" fill="#101828" />
      <path d="M12 16.9998V10.9998M9 13.9998H15" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
export const displayName = "AddOrderModalIcon";
